import PropTypes from 'prop-types';
export const FILE_HANDLER_VARIANTS = {
  DEFAULT: 'default',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  REMOVED: 'removed'
};
export const variantPropType = PropTypes.oneOf(Object.values(FILE_HANDLER_VARIANTS));
//# sourceMappingURL=consts.js.map